import { SelectBox } from '@components/selectbox';
// import { InfoIcon } from '@icons/InfoIcon';
import { cn } from '@utils/helpers';
import { InfoIcon } from 'lucide-react';
import { useFragment } from 'react-relay';
import { labeledSelectBoxFragment } from './LabeledSelectBox.relay';
import type { LabeledSelectBoxProps } from './types';

const LabeledSelectBox: React.FC<LabeledSelectBoxProps> = (props: LabeledSelectBoxProps) => {
  const labeledSelectBox = useFragment(labeledSelectBoxFragment, props.labeledSelectBox);

  const classNames = ['LabeledSelectBox', 'z-10', 'float-right', 'flex', 'items-center', 'justify-between', 'text-sm', 'text-[#4a4a4a]', '[&>*]:ml-[5px]', '[&>*:first-child]:mr-[5px]'];
  props.pushUp && classNames.push('LabeledSelectBox-pushUp');
  props.pushRight && classNames.push('LabeledSelectBox-pushRight');
  props.className && classNames.push(props.className);

  if (props.pushUp) {
    classNames.push('-mt-[5.5em]');
  }
  if (props.pushRight) {
    classNames.push('absolute', 'right-0', 'top-0');
  }

  return (
    <div className={cn('flex flex-col items-start gap-1 desktop:flex-row desktop:items-center', classNames.join(' '))}>
      {props.info ? <InfoIcon className="text-gray-400 w-5 h-5" /> : null}
      {labeledSelectBox.label}
      <SelectBox selected={props.selected} selectBox={labeledSelectBox.selectbox} onChange={props.onChange} width={props.width} sort={props.sort} filter={props.filter} />
    </div>
  );
};

export { LabeledSelectBox };
